export const HASURA_ENDPOINT_DEV = "hasura.tryhyperclapper.click/v1/graphql";
export const BASE_ENDPOINT =
  "https://us-central1-hyperclapper.cloudfunctions.net";

// export const BASE_ENDPOINT = "http://localhost:5001/hyperclapper/us-central1";

// export const BACKEND_URL = "http://localhost:4004";
export const BACKEND_URL =
  "https://imwei6b550.execute-api.us-east-1.amazonaws.com/prod";

export const firebaseConfig = {
  apiKey: "AIzaSyBWfkVMXoJswG_8SGTX-F8Qwbrj8Fp13P0",
  authDomain: "hyperclapper.firebaseapp.com",
  projectId: "hyperclapper",
  storageBucket: "hyperclapper.appspot.com",
  messagingSenderId: "711915071503",
  appId: "1:711915071503:web:fd350eb83ade180a6c9b7a",
  measurementId: "G-0WEZSTNB4P",
};

// export const SQUARE_APP_ID = "sandbox-sq0idb-_9DobTRwDcPefw9-V9IUqw";
// export const SQUARE_LOCATION_ID = "LA6W26ZRT180T";

export const SQUARE_APP_ID = "sq0idp-Ds5qBUeN2-0vxl3trqADxg";
export const SQUARE_LOCATION_ID = "LKST69344K0T3";

export const OLD_EXTENSION_ID = "ljbhjiphihljbohlafdlhpagknidhifj";

export const NEW_EXTENSION_ID = "gkmphkjkphmhhlldbbkdlnccbikjcngl";

export const NEW_EXTENSION =
  "https://chromewebstore.google.com/detail/hyperclapper-ai-powered-n/gkmphkjkphmhhlldbbkdlnccbikjcngl";
